import {Input, SearchIcon} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback} from 'react'

import {useQuerySync} from '../../hooks'

type Props = {
  value?: string
  placeholder?: string
}

const Search: React.FC<Props> = ({placeholder, value}: Props) => {
  const t = useI18n()

  const [queryValue, handleChange] = useQuerySync('s', value ?? '')
  const handleClear = useCallback(() => handleChange(''), [handleChange])

  return (
    <Input
      label={placeholder ?? t('header.search')}
      lead={<SearchIcon />}
      onChange={handleChange}
      onClear={handleClear}
      size="s"
      value={queryValue}
      clearable
    />
  )
}

export default Search
